var EventEmitter = (function () {
    function EventEmitter() {
        this.listeners = {};
    }
    EventEmitter.prototype.on = function (eventName, fn) {
        this.listeners[eventName] = this.listeners[eventName] || [];
        this.listeners[eventName].push(fn);
        return this;
    };
    EventEmitter.prototype.off = function (eventName, fn) {
        if (fn) {
            this.listeners[eventName] = (this.listeners[eventName] || []).filter(function (_fn) { return fn !== _fn; });
        }
        else {
            delete this.listeners[eventName];
        }
        return this;
    };
    EventEmitter.prototype.emit = function (eventName, params) {
        var _this = this;
        (this.listeners[eventName] || []).forEach(function (listener) {
            listener.call(_this, params);
        });
        return this;
    };
    return EventEmitter;
}());
export default EventEmitter;
